import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { padding, system } from 'styled-system';

import sx from '../../internal/styles/sx';
import { TableHeadProps } from './types';

const TableHead = styled('thead', { shouldForwardProp })<TableHeadProps>(
  {
    boxSizing: 'border-box',
    fontWeight: 'normal',
  },
  padding,
  system({
    fontSize: {
      property: 'fontSize',
      scale: 'fontSizes',
    },
  }),
  sx
);

export default TableHead;
